import httpClient, { setAuthToken } from './httpClient'

export default {
  login(loginData) {
    return httpClient.post('login', loginData, { withCredentials: true }).then(r => r.data)
  },
  renewalToken(token) {
    return httpClient.post('renewal', { token }).then(r => r.data)
  },
  getProfile() {
    return httpClient.get('auth').then(r => r.data)
  },
  setAuthToken
}
